module.exports = __webpack_public_path__ + "img/location.0d3621af.png";